import React, { useState } from 'react';
import MobileSidebar from '../components/MobileSidebar/MobileSidebar';
import styles from './HomePage.module.css';

export default function HomePage(props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className={`flex-col ${styles['page']} ${props.className}`}>
      <MobileSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* 头部导航 */}
      <div className={`flex-col self-stretch ${styles['section']}`}>
        <div className={`flex-col justify-start ${styles['section_2']}`}>
          <div className={`flex-row justify-between items-center ${styles['section_3']}`}>
            <img
              className={`${styles['image_2']}`}
              src="/images/logos/ntx-logo-full.png"
              alt="Logo"
            />

            {/* 桌面端导航菜单 */}
            <div className={`flex-row items-center ${styles['desktop-nav']}`}>
              <div className={`flex-row shrink-0`}>
                <span className={`${styles['font_2']} ${styles['nav-link']}`} onClick={() => scrollToId('section-hero')}>立即开始</span>
                <span className={`${styles['font_2']} ${styles['text_3']} ${styles['ml-51']} ${styles['nav-link']}`} onClick={() => scrollToId('section-about')}>关于NTX</span>
              </div>
              <span className={`${styles['font_2']} ${styles['text_4']} ${styles['ml-69']} ${styles['nav-link']}`} onClick={() => scrollToId('section-partners')}>合作伙伴</span>
              <div className={`flex-row items-center shrink-0 ${styles['ml-69']}`}>
                <span className={`${styles['font_2']} ${styles['text_5']} ${styles['nav-link']}`} onClick={() => scrollToId('section-community')}>相关服务</span>
                <div className={`ml-44 flex-row shrink-0`}>
                  <a href="https://app.ntxdao.com/login" target="_blank" rel="noreferrer" className={`${styles['link-reset']}`}>
                    <div className={`flex-col justify-start items-center shrink-0 ${styles['text-wrapper']}`}>
                      <span className={`${styles['font']} ${styles['text']}`}>Sign In</span>
                    </div>
                  </a>
                  <a href="https://app.ntxdao.com/register" target="_blank" rel="noreferrer" className={`${styles['link-reset']} ${styles['ml-13']}`}>
                    <div className={`flex-col justify-start items-center shrink-0 ${styles['text-wrapper_2']}`}>
                      <span className={`${styles['font']} ${styles['text_2']}`}>Sign Up</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            {/* 移动端导航菜单 */}
            <div className={`flex-row items-center ${styles['mobile-nav']}`}>
              <img
                className={`ml-20 shrink-0 ${styles['menu-icon']}`}
                src="/images/more.png"
                onClick={toggleSidebar}
                style={{ cursor: 'pointer' }}
                alt="Menu"
              />
            </div>
          </div>
        </div>

        {/* Hero Section */}
        <div className={`flex-col items-center ${styles['hero']}`} id="section-hero">
          <div className={`flex-col items-center ${styles['hero-content']}`}>
            <span className={`${styles['text_6']}`}>交易即挖矿</span>
            <span className={`${styles['font_3']} ${styles['text_7']}`}>
              连接用户聚合资源-把握你的Web3 机会
            </span>
            <div className={`flex-row ${styles['hero-cta']}`}>
              <a href="https://app.ntxdao.com/" target="_blank" rel="noreferrer" className={`${styles['link-reset']}`}>
                <div className={`flex-col justify-start items-center ${styles['text-wrapper_3']}`}>
                  <span className={`${styles['font_4']} ${styles['text_8']}`}>立即开始</span>
                </div>
              </a>
              <a href="https://app.ntxdao.com/" target="_blank" rel="noreferrer" className={`${styles['link-reset']}`}>
                <div className={`flex-col justify-start items-center ${styles['text-wrapper_4']}`}>
                  <span className={`${styles['font_4']} ${styles['text_9']}`}>下载APP</span>
                </div>
              </a>
            </div>
          </div>
          <img
            className={`${styles['image_4']}`}
            src="/images/group-3-alt.png"
            alt="Hero"
          />
        </div>
      </div>

      {/* 加入NTX后如何盈利 */}
      <span className={`self-center ${styles['font_5']} ${styles['text_10']}`}>加入NTX后如何些盈利?</span>
      <div className={`${styles['profit-section']}`} id="section-about">
        <img
          className={`${styles['profit-image']}`}
          src="/images/c7.png"
          alt="加入NTX后如何些盈利"
        />
      </div>

      {/* NTX合作伙伴 */}
      <span className={`self-center ${styles['font_5']} ${styles['text_20']}`}>NTX合作伙伴</span>
      <div className={`${styles['partners-grid']}`} id="section-partners">
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/binance.png" alt="Binance" />
          <span className={`${styles['partner-name']}`}>Binance</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/htx.png" alt="HTX" />
          <span className={`${styles['partner-name']}`}>HTX</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/gate.png" alt="Gate" />
          <span className={`${styles['partner-name']}`}>Gate</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/bybit.png" alt="Bybit" />
          <span className={`${styles['partner-name']}`}>Bybit</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/matrixport.png" alt="Matrixport" />
          <span className={`${styles['partner-name']}`}>Matrixport</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/xt.png" alt="XT" />
          <span className={`${styles['partner-name']}`}>XT</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/hotcoin.png" alt="Hotcoin" />
          <span className={`${styles['partner-name']}`}>Hotcoin</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/bitget.png" alt="Bitget" />
          <span className={`${styles['partner-name']}`}>Bitget</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/okx.png" alt="OKX" />
          <span className={`${styles['partner-name']}`}>OKX</span>
        </div>
        <div className={`${styles['partner-item']}`}>
          <img className={`${styles['partner-icon']}`} src="/images/partners/pokepay.png" alt="Pokepay" />
          <span className={`${styles['partner-name']}`}>Pokepay</span>
        </div>
      </div>

      {/* Banner图片 */}
      <img
        className={`self-center ${styles['image_14']}`}
        style={{ maxWidth: "100vx" }}
        src="/images/hero.png"
        alt="Banner"
      />

      {/* NTX社群 */}
      <div className={`flex-col self-stretch ${styles['group_13']}`} id="section-community">
        <span className={`self-start ${styles['font_5']} ${styles['text_25']}`}>NTX社群</span>
        <div className={`mt-42 flex-row self-stretch`}>
          <a href="https://x.com/NexTradeDao" target="_blank" rel="noreferrer" className={`${styles['link-reset']}`}>
            <div className={`flex-row items-center ${styles['section_7']}`}>
              <img
                className={`${styles['image_15']} ${styles['image_16']}`}
                src="/images/group-1.png"
                alt="Twitter"
              />
              <span className={`ml-16 ${styles['font_9']} ${styles['text_27']}`}>Twitter</span>
            </div>
          </a>
          <a href="https://t.me/ntx_dao" target="_blank" rel="noreferrer" className={`${styles['link-reset']} ${styles['ml-23']}`}>
            <div className={`flex-row items-center ${styles['section_7']}`}>
              <img
                className={`${styles['image_15']} ${styles['image_17']}`}
                src="/images/group-2.png"
                alt="Telegram"
              />
              <span className={`ml-12 ${styles['font_9']} ${styles['text_26']}`}>Telegram</span>
            </div>
          </a>
        </div>
      </div>

      {/* Footer */}
      <div className={`flex-col justify-start items-center self-stretch ${styles['text-wrapper_5']}`}>
        <span className={`${styles['text_28']}`}>© 2025 NexTradeDAO. All rights reserved.</span>
      </div>
    </div>
  );
}

HomePage.defaultProps = { className: '' };
